var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGflArenaIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "158px",
    height: "158px",
    viewBox: "0 0 158 158",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 20") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "37.9433832%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6A566",
    stopOpacity: 0.444479349,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GFL-Marketing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GFL--Arena---Version-2.0",
    transform: "translate(-1322, -6492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(1322, 6492)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "url(#linearGradient-1)",
    cx: 79,
    cy: 79,
    r: 79
  }), /*#__PURE__*/React.createElement("g", {
    id: "star_24dp_FFFFFF_FILL0_wght400_GRAD0_opsz24",
    transform: "translate(35, 37)",
    fill: "#C6A566",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4825,66.3223684 L44.5,57.8223684 L58.5175,66.4342105 L54.84625,50.3289474 L67.195,39.5921053 L50.9525,38.1381579 L44.5,22.9276316 L38.0475,38.0263158 L21.805,39.4802632 L34.15375,50.3289474 L30.4825,66.3223684 Z M17.02125,85 L24.2525,53.5723684 L0,32.4342105 L32.04,29.6381579 L44.5,0 L56.96,29.6381579 L89,32.4342105 L64.7475,53.5723684 L71.97875,85 L44.5,68.3355263 L17.02125,85 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGflArenaIcon2);
export default __webpack_public_path__ + "static/media/gfl-arena-icon2.9bd69bc4d36df11c265700178e11da9a.svg";
export { ForwardRef as ReactComponent };